"use strict";

exports.__esModule = true;
exports.HistoricalPartCountToolbar = HistoricalPartCountToolbar;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Calendar = require("../../Calendar");
var _MultiDeviceSelector = require("../../Device/MultiDeviceSelector/MultiDeviceSelector");
var _Core = require("../../Core");
var _URLFilter = require("../../Core/URLFilter");
var _Device = require("../../Device");
var _Time = require("../../Time");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var PartCountToolbar = (0, _styledComponents["default"])(_Core.Toolbar).withConfig({
  displayName: "HistoricalPartCountToolbar__PartCountToolbar",
  componentId: "sc-j8fku2-0"
})(["display:flex;min-width:980px;"]);
function HistoricalPartCountToolbar(props) {
  var style = props.style,
    devices = props.devices;
  var _useContext = (0, _react.useContext)(_Calendar.CalendarContext),
    calendar = _useContext.calendar;
  var time = (0, _react.useContext)(_Time.TimeContext);
  var urlFilter = (0, _react.useContext)(_URLFilter.URLFilterContext);
  var deviceTags = (0, _react.useContext)(_Device.DeviceTagListContext);
  var currentPlantWorkdayId = (0, _Calendar.getDate)(time.currentWorkday.interval.endMillis);
  var filters = urlFilter.filters,
    setFilter = urlFilter.setFilter;
  var selectedDates = filters == null ? void 0 : filters.period.split("/");
  return /*#__PURE__*/_react["default"].createElement(PartCountToolbar, {
    "data-testid": "HistoricalPartCountToolbar",
    style: style
  }, /*#__PURE__*/_react["default"].createElement(_MultiDeviceSelector.MultiDeviceSelector, {
    style: {
      maxWidth: 200
    },
    devices: devices,
    tags: deviceTags,
    selectAllByDefault: true,
    selected: filters.device,
    onSelect: function onSelect(devices) {
      return setFilter("device", devices.map(function (device) {
        return device.uuid;
      }));
    }
  }), /*#__PURE__*/_react["default"].createElement(_Time.WorkdayRangeSelector, {
    maxDate: currentPlantWorkdayId,
    selected: [new Date(selectedDates[0]), new Date(selectedDates[1])],
    onSelect: function onSelect(selected) {
      if (selected.length === 0) {
        return;
      }
      var interval = calendar.getIntervalForWorkdays((0, _Calendar.toDateString)(selected));
      var parts = [new Date(interval.startMillis).toISOString(), new Date(interval.endMillis).toISOString()];
      return setFilter("period", parts.join("/"));
    }
  }));
}